import { publicComponentOption } from "dependencies/base"
import { toSelectOpt } from "utils"
const optDes = {
  ...publicComponentOption,
  showHeader: "显示表头",
  isShowSerialNumber: "显示序号",
  headerBgColor: "表头背景色",
  headerHeight: "表头高度",
  headerFontFamily: "表头字体",
  headerFontSize: "表头字体大小",
  headerFontWeight: "表头字重",
  headerFontColor: "表头字体颜色",
  showColsType: "显示全部列",
  showCols: "显示列数",
  colsWidthType: "列数类型", // "default": 平均宽度;"auto":自定义宽度
  autoWidthType: "超出一行的显示方式", //  "wrap":换行显示；"float"：鼠标悬浮显示
  showRowsType: "显示全部行",
  showRows: "显示行数",
  rowsHeight: "行高",
  oddBgColorType: "奇数行颜色",
  oddBgColor: "奇数行背景颜色",
  oddBgStartColor: "奇数行背景渐变开始色",
  oddBgEndColor: "奇数行背景渐变结束色",
  evenBgColorType: "偶数行颜色",
  evenBgColor: "偶数行背景色",
  evenBgStartColor: "偶数行背景渐变开始色",
  evenBgEndColor: "偶数行背景渐变结束色",
  defaultFontFamily: "默认行字体",
  defaultFontSize: "默认行字体大小",
  defaultFontWeight: "默认行字重",
  defaultFontColor: "默认行字体颜色",
  overflowText: "超出显示方式",
  showPagination: "显示分页",
  selectCellBgColor: "选中单元格背景色",
  selectCellFontFamily: "选中单元格字体",
  selectCellFontSize: "选中单元格字体大小",
  selectCellFontWeight: "选中单元格字重",
  selectCellFontColor: "选中单元格文字颜色",
  turnOnScroll: "开启滚动",
  updateTimer: "数据轮询时间",
  restDataUrl: "外接数据源地址"
}
export const getOptDes = toSelectOpt.bind(this, optDes)
